import { CircleX } from "lucide-react";
import React, { useContext, useEffect } from "react";
import { ActionIcon } from "@mantine/core";
import { Navigate } from "react-router-dom";
import { HttpClientError } from "../../../providers/HttpClient";
import { queryClient } from "../../../App";
import { AuthContext } from "../../../providers/AuthProvider";
import EmployeeDataImportListRequest from "../services/request/EmployeeDataImportListRequest";
import useCancelEmployeeImportDataApiService from "../services/api/CancelEmployeeImportDataApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type CancelEmployeeImportActionIconProps = {
  id: number;
};

const CancelEmployeeImportActionIcon: React.FC<
  CancelEmployeeImportActionIconProps
> = ({ id }) => {
  const auth = useContext(AuthContext);
  const { showToast } = useToasts();

  const { isLoading, isSuccess, isError, mutate, error } =
    useCancelEmployeeImportDataApiService();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "employee_data_import_cancel_failed",
        data: { message: HttpClientError(error) },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess && auth?.employer?.id) {
      showToast({ strapiId: "employee_data_import_cancel_success" });

      const request: EmployeeDataImportListRequest = {
        employer_id: auth.employer.id,
      };

      queryClient
        .invalidateQueries([
          "EmployeeDataImportListApiService",
          ...Object.values(request),
        ])
        .then();
    }
  }, [isSuccess]);

  if (!auth) {
    return <Navigate replace to="/login" />;
  }

  return (
    <ActionIcon
      loading={isLoading}
      onClick={() => {
        mutate(id);
      }}
    >
      <CircleX size={18} />
    </ActionIcon>
  );
};

export default CancelEmployeeImportActionIcon;
